export default __webpack_public_path__ + "dc9fe0587ee1b4e0bc55cc0536d5996b.svg";